/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PlanChangeApprovalRequest,
    PlanChangeApprovalRequestFromJSON,
    PlanChangeApprovalRequestFromJSONTyped,
    PlanChangeApprovalRequestToJSON,
} from './PlanChangeApprovalRequest';

/**
 * 
 * @export
 * @interface GetPlanChangeApprovalRequest
 */
export interface GetPlanChangeApprovalRequest {
    /**
     * status code
     * @type {number}
     * @memberof GetPlanChangeApprovalRequest
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetPlanChangeApprovalRequest
     */
    message: string;
    /**
     * 
     * @type {PlanChangeApprovalRequest}
     * @memberof GetPlanChangeApprovalRequest
     */
    data: PlanChangeApprovalRequest;
}

export function GetPlanChangeApprovalRequestFromJSON(json: any): GetPlanChangeApprovalRequest {
    return GetPlanChangeApprovalRequestFromJSONTyped(json, false);
}

export function GetPlanChangeApprovalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPlanChangeApprovalRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PlanChangeApprovalRequestFromJSON(json['data']),
    };
}

export function GetPlanChangeApprovalRequestToJSON(value?: GetPlanChangeApprovalRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PlanChangeApprovalRequestToJSON(value.data),
    };
}

